import { AppRegistry } from "react-native";
import App from "./App";
import appConfig from "./app.json"; // Handle as default export
const appName = appConfig.name;

// Register for mobile (native platforms)
AppRegistry.registerComponent(appName, () => App);

// Register for web
if (typeof document !== "undefined") {
  AppRegistry.runApplication(appName, {
    initialProps: {},
    rootTag: document.getElementById("root"),
  });
}
